const searchAliases = [[" und ", " + "]];
const getAlternativeTerms = (searchTerm) => {
  return searchAliases.reduce((alternativeTerms, [matcher, replacement]) => {
    const regex = new RegExp(matcher, "i");
    if (regex.test(searchTerm)) {
      return [...alternativeTerms, searchTerm.replace(regex, replacement)];
    }
    return alternativeTerms;
  }, []);
};
const getSuggestions = (searchTerm, config) => {
  const { fuse, getOptionKey } = config;
  const alternativeTerms = [searchTerm, ...getAlternativeTerms(searchTerm)];
  return alternativeTerms.reduce((suggestions, currentSearchTerm) => {
    const previousSuggestionsKeys = suggestions.map(getOptionKey);
    const newSuggestions = fuse.search(currentSearchTerm);
    const exactMatch = newSuggestions.find(({ score }) => score === Number.EPSILON);
    if (exactMatch)
      return [exactMatch.item];
    const newUniqueSuggestions = newSuggestions.filter((suggestion) => previousSuggestionsKeys.indexOf(getOptionKey(suggestion.item)) === -1).map(({ item }) => item);
    return [...suggestions, ...newUniqueSuggestions];
  }, []);
};
const insuranceFieldHelpers = {
  getAlternativeTerms,
  getSuggestions
};
export {
  insuranceFieldHelpers,
  searchAliases
};
